import { render, staticRenderFns } from "./kiwikkrrush-swiper.vue?vue&type=template&id=3af7e131&"
import script from "./kiwikkrrush-swiper.vue?vue&type=script&lang=js&"
export * from "./kiwikkrrush-swiper.vue?vue&type=script&lang=js&"
import style0 from "./kiwikkrrush-swiper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports